




























































































import mixins from '@/utils/mixins';
import QuoteStateMixin from '@/mixins/quoteState';
import auth from '@/mixins/auth';
import { mapActions, mapGetters } from 'vuex';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import { ErrorManager } from '@/models/error';
import { IQuoteData, QuoteFieldError } from '@/models';
import QuoteDocumentBuilderDialog from '@/components/quotes/QuoteDocumentBuilderDialog.vue';
import QuoteCreateSalesOpportunityListItem from '../QuoteCreateSalesOpportunityListItem.vue';

export default mixins(QuoteStateMixin, auth).extend({
  components: {
    ErrorAlert,
    QuoteDocumentBuilderDialog,
    QuoteCreateSalesOpportunityListItem
  },

  name: 'QuoteCustomerLostStateCard',

  computed: {
    ...mapGetters({
      getQuoteById: 'quote/getQuoteById'
    }),

    getColor(): string {
      return 'reject';
    },

    getIcon(): string {
      return 'mdi-close';
    },

    getString(): string {
      return 'Proposal Lost';
    },

    getActionText(): string {
      return '';
    }
  },

  data: () => ({
    loading: false,
    rfqDateValue: null as string | null,

    quoteHeaderRules: [(v: any) => !!v || 'This field is required'],

    fieldError: new QuoteFieldError()
  }),

  methods: {
    ...mapActions({
      createQuoteRevision: 'quote/createQuoteRevision'
    }),

    async createRevision(quoteData: IQuoteData) {
      this.clearAllErrors();
      this.loading = true;

      return this.createNewQuoteRevision(quoteData).catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
          if (QuoteFieldError.isQuoteFieldError(error.response.data)) {
            this.fieldError = new QuoteFieldError(error.response.data);
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
        //because the page is reloaded there's no need to reset loading flag on finally
        this.loading = false;
      });
    }
  }
});
